import axios from "axios";

const axiosClient = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? "http://127.0.0.1:5000" : "",
    headers: {
        'Content-Type': 'application/json',
    },
    responseType: 'json'
});

export const fetchForms = async (path) => {
    const response = await axiosClient.get(
        `/fields${path}`,
    ).then(
        (response) => {
            return response
        })
        .catch((err) => {
            console.log("ERROR", err);
            return [];
        });
    return response.data
}

export const postForms = async (path, postData) => {
    const response = await axiosClient.post(
        `/fields${path}`, postData
    ).then(
        (response) => {
            return response
        })
        .catch((err) => {
            return err;
        });
    return response
}